import { UrlQueryOperator } from '/@/modules/core/app/constants/UrlQueryOperator';
import { TableFilter } from '/@/modules/core/table/models/TableFilter';

export const TableFilterMixin = {
  props: {
    tableFilter: {
      type: TableFilter,
      required: true
    },
    operatorOptions: {
      type: Array,
      default: () => [UrlQueryOperator.IN]
    }
  }
};
